import { Component, effect, forwardRef, input, model } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { toPartialTime } from '@core/utils/time-utils';

import {
  FieldTime,
  FormBuilderBase
} from '@shared/components/row-edition-form/form-builder/form-builder.model';

import { unwrapValue, wrapValue } from '../row-edition-form.utils';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimeComponent),
      multi: true
    }
  ]
})
export class TimeComponent implements ControlValueAccessor {
  id = input<FormBuilderBase['id']>();
  value = model.required<string | null>();
  min = input<FieldTime['minTime']>();
  max = input<FieldTime['maxTime']>();
  required = input<FormBuilderBase['required']>();
  wrapperProperty = input<string | undefined>(undefined);

  constructor() {
    effect(() => {
      const value = this.value();
      this.onChange(value);
    });
  }

  onChange = (_value: string | null) => {};
  onTouched = () => {};

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.onChange(toPartialTime(value));
  }

  writeValue(value: string): void {
    this.value.set(unwrapValue(value, this.wrapperProperty()) as string);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChange = (value: string | null) => fn(wrapValue(value, this.wrapperProperty()));
  }
  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }
}
